export default __webpack_public_path__ + "static/media/Tasks at Routinely Arnav Mundkur.2932dc5b.pdf";